import styled, { css } from 'styled-components';
import { lineClampCss } from '../../../helpers/lineClampCss';
import { FocusStyles, FocusStylesInverted } from '../../../styles/FocusStyles';
export const PrimaryButtonThemeConfig = {
    primary: {
        default: {
            color: 'white',
            bgColor: 'primary',
            shadowColor: 'primary-hover',
        },
        disabled: {
            color: 'white',
            bgColor: 'anthracite-40',
            shadowColor: 'anthracite-70',
        },
    },
    white: {
        default: {
            color: 'primary',
            bgColor: 'white',
            shadowColor: 'anthracite-30',
        },
        disabled: {
            color: 'anthracite-70',
            bgColor: 'white',
            shadowColor: 'anthracite-30',
        },
    },
    'yellow-100': {
        default: {
            color: 'darkergrey',
            bgColor: 'yellow-100',
            shadowColor: 'yellow-hover',
        },
        disabled: {
            color: 'white',
            bgColor: 'anthracite-40',
            shadowColor: 'anthracite-70',
        },
    },
};
export const SecondaryButtonThemeConfig = {
    primary: {
        default: {
            color: 'primary',
            underlineColor: 'primary',
        },
        disabled: {
            color: 'normalgrey',
            underlineColor: 'normalgrey',
        },
        hover: {
            color: 'primary-hover',
            underlineColor: 'primary-hover',
        },
    },
    white: {
        default: {
            color: 'white',
            underlineColor: 'white',
        },
        disabled: {
            color: 'anthracite-30',
            underlineColor: 'anthracite-30',
        },
        hover: {
            color: 'anthracite-30',
            underlineColor: 'white',
        },
    },
};
const resetStyles = css `
  border: 0;
  padding: 0;
  margin: 0;
  appearance: none;
  height: auto;
  width: auto;
  text-decoration: none;
  font: inherit;
  background-color: transparent;
`;
const commonStyles = css `
  ${resetStyles}

  display: inline-block;
  position: relative;
  font-family: ${({ theme: { fonts } }) => fonts.serif};
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  ${({ disabled }) => disabled && 'pointer-events: none'};
`;
export const PrimaryButtonWrapperSpanStyles = styled.span `
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  height: 100%;
`;
export const LineClamp = styled.span `
  ${lineClampCss(1)}

  // corrigate font-height
  position: relative;
  top: 1px;
`;
export const PrimaryCTAStyles = styled.button `
  ${({ theme: { colorContext } }) => colorContext === 'dark' ? FocusStylesInverted : FocusStyles}
  ${({ disabled, theme: { colors }, config }) => {
    return css `
      ${commonStyles}
      border: none;
      border-radius: 6.25rem;
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 1.2;
      margin: 0.125rem 0 0.25rem;
      padding: 0 1rem;
      text-align: center;
      text-transform: uppercase;
      height: 2.5rem;
      background-color: ${colors[config.bgColor]};
      color: ${colors[config.color]};
      box-shadow: 0 0.25rem ${colors[config.shadowColor]};

      ${!disabled &&
        css `
        &:hover,
        &:focus {
          top: -0.125rem;
          box-shadow: 0 0.375rem ${colors[config.shadowColor]};
        }

        &:active,
        &:focus {
          top: 0.125rem;
          box-shadow: 0 0.125rem ${colors[config.shadowColor]};
        }
      `}
    `;
}}
`;
export const SecondaryCTA = styled.button `
  ${({ theme: { colorContext } }) => colorContext === 'dark' ? FocusStyles : FocusStylesInverted}

  ${({ color, disabled, theme: { colors, colorContext } }) => {
    const colorOverwrite = colorContext === 'dark' && !disabled ? color : undefined;
    const themeConfig = SecondaryButtonThemeConfig[colorContext === 'dark' ? 'white' : 'primary'];
    const stateConfig = colorOverwrite
        ? { color: colorOverwrite, underlineColor: colorOverwrite }
        : themeConfig[disabled ? 'disabled' : 'default'];
    return css `
      ${commonStyles}
      font-size: 1rem;
      font-weight: 300;
      color: ${colors[stateConfig.color]};
      line-height: 1.375;
      text-decoration: underline ${colors[stateConfig.underlineColor]};
      z-index: 0;

      &:hover {
        color: ${colors[themeConfig['hover'].color]};
        text-decoration-color: ${colors[themeConfig['hover'].underlineColor]};
      }
    `;
}}
`;
